/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const da_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const de_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const en_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const es_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const fr_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const hu_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const it_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const nl_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const pl_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const pt_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

const sv_regions_us_oklahoma3 = /** @type {(inputs: {}) => string} */ () => {
	return `Oklahoma`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const regions_us_oklahoma3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.regions_us_oklahoma3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("regions_us_oklahoma3", locale)
	if (locale === "cs") return cs_regions_us_oklahoma3(inputs)
	if (locale === "da") return da_regions_us_oklahoma3(inputs)
	if (locale === "de") return de_regions_us_oklahoma3(inputs)
	if (locale === "en") return en_regions_us_oklahoma3(inputs)
	if (locale === "es") return es_regions_us_oklahoma3(inputs)
	if (locale === "fr") return fr_regions_us_oklahoma3(inputs)
	if (locale === "hu") return hu_regions_us_oklahoma3(inputs)
	if (locale === "it") return it_regions_us_oklahoma3(inputs)
	if (locale === "nl") return nl_regions_us_oklahoma3(inputs)
	if (locale === "pl") return pl_regions_us_oklahoma3(inputs)
	if (locale === "pt") return pt_regions_us_oklahoma3(inputs)
	return sv_regions_us_oklahoma3(inputs)
};
export { regions_us_oklahoma3 as "regions.US.Oklahoma" }